module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "unset"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (!_vm.contratos.length) ? _c('tr', [_c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "40%"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('a', {
      staticClass: "text-cap custom-link "
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.contratos), function(contrato, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_vm._v(" " + _vm._s(contrato.nome))]), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-button-group', {
      staticClass: "hidden-print",
      attrs: {
        "options": _vm.contratoOptions
      },
      on: {
        "change": function($event) {
          return _vm.relacionarUsuarioContrato(index)
        }
      },
      model: {
        value: (contrato.ativado),
        callback: function($$v) {
          _vm.$set(contrato, "ativado", $$v)
        },
        expression: "contrato.ativado"
      }
    })], 1)])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Ação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e2572d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/usuarios/components/UsuarioContratos.vue
// module id = 1499
// module chunks = 17